import { SectionAssetDto } from '@unistocks/proxy/axios-client';
import { noop } from '@unistocks/shared/utils/util';
import { createContext, use } from 'react';

type AssetSettingsContextValue = {
  openSettings: (asset: SectionAssetDto) => void;
};

export const AssetSettingsContext = createContext<AssetSettingsContextValue>({
  openSettings: noop
});

export const useAssetSettings = () => use(AssetSettingsContext);
